import React, { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async"; // Add this import
import Navbar from "./components/navbar";
import AppRoutes from "./routes/routes";
import { AuthProvider } from "./context/authContext";
import Footer from "./components/Footer";
import "../src/css/custom.css";
import ReactGA from "react-ga4";
// import FloatingButton from "./components/floatingButton";

// Initialize GA outside the component or in a separate configuration file if preferred
// Ensure this is your correct GA4 Measurement ID
const GA_MEASUREMENT_ID = "G-CLVMZ7TEE2";
ReactGA.initialize(GA_MEASUREMENT_ID);

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Send a pageview hit every time the location changes
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search, title: document.title });
    // console.log(`GA Pageview sent: ${location.pathname + location.search}`);
  }, [location]);

  return null; // This component does not render anything
}

function App() {
  // The initial pageview can be sent here or rely on the AnalyticsTracker for the first load.
  // For simplicity, AnalyticsTracker will handle the first load as well when location changes for the first time.

  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <AnalyticsTracker /> {/* Add the tracker here */}
          <Navbar />
          <AppRoutes />
          <Footer />
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
